<template>
  <component
    :is="component"
    v-if="component"
  />
</template>

<script>
import VueWithCompiler from 'vue/dist/vue.esm'
import createMarkdownToTemplate from '~/javascripts/helper/markdownToTemplate'

const markdownToTemplate = createMarkdownToTemplate()

export default {
  name: 'CmsRenderer',
  props: {
    markdown: {
      type: String,
      default: '',
    },
  },
  computed: {
    component() {
      const template = markdownToTemplate(this.markdown)
      if (!template) {
        return null
      }
      return VueWithCompiler.component('cms-renderer-dynamic', {
        template: `<div class="cms-widget">${template}</div>`,
      })
    },
  },
}
</script>

<style lang="scss">
@import 'index';
</style>
